import i18n from '../../language/index'
import {create_title} from '@/base/titleData'

export default {
  pc_infor: {
    marginTop: '5%',
    marginLeft: '20%',
    marginRight: '20%',
    marginBottom: '5%',
    textAlign: 'left'
  },
  mb_infor: {
    marginTop: '0%',
    marginLeft: '0%',
    marginRight: '0%',
    marginBottom: '0%',
    textAlign: 'center'
  },
  pc_widgets_infor: {
    title: create_title(i18n.t('widgets_basic_retrieve_password_edit_2807'))
  },
  mb_widgets_infor: {
    title: create_title(i18n.t('widgets_basic_retrieve_password_edit_2807'))
  },
  animateCombObj: {
    value: 0,
    animate: {
      _key: 'none'
    }
  },
  animateType: 'module_animation',
  listArr: {
  },
}



// WEBPACK FOOTER //
// ./src/widgets/basic_retrieve_password/style.js